import styled from 'styled-components'

export const LookupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
